import { render, staticRenderFns } from "./g-order-production-marking.vue?vue&type=template&id=6b041c7a&scoped=true&"
import script from "./g-order-production-marking.vue?vue&type=script&lang=ts&setup=true&"
export * from "./g-order-production-marking.vue?vue&type=script&lang=ts&setup=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b041c7a",
  null
  
)

export default component.exports